import { Box, Typography } from '@mui/material';
import { CUSTOM_BENEFIT_ICONS } from 'probonio-shared-ui/component/icon';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { BenefitButtonWithChevron } from '../BenefitButtonwithChevron';
import { CustomBenefitTemplate, CustomBenefitTemplateKeys } from './useCustomBenefitTemplates';

interface Props {
  customBenefit: CustomBenefitTemplate;
  customBenefitKey: CustomBenefitTemplateKeys;
  onClick: (customBenefit: CustomBenefitTemplate, customBenefitKey: CustomBenefitTemplateKeys) => void;
  isConfigured: boolean;
}
export const CustomBenefitItem: React.FC<Props> = ({ customBenefit, customBenefitKey, onClick, isConfigured }) => {
  const { t } = useTranslation();
  const handleOpenModal = useCallback(() => {
    onClick(customBenefit, customBenefitKey);
  }, [customBenefit, customBenefitKey, onClick]);

  const Icon = CUSTOM_BENEFIT_ICONS[customBenefit.iconValue];
  return (
    <Box
      sx={{
        my: 0.5,
        height: '100%',
      }}
    >
      <BenefitButtonWithChevron
        dataTestId={t(customBenefit.title)}
        sx={{ backgroundColor: 'background.paper', height: '100%', py: 2 }}
        color="secondary"
        onClick={handleOpenModal}
        icon={<Icon color="primary" fontSize="large" sx={{ mr: 1 }} />}
        header={<Typography variant="h2">{t(customBenefit.title)}</Typography>}
        content={
          <Typography
            sx={{
              mt: 0.5,
            }}
          >
            {t(customBenefit.description)}
          </Typography>
        }
        isConfigured={isConfigured}
      />
    </Box>
  );
};
